export enum StatusTwygoCourses {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  COMPLETED = 2,
  FAILED = 3,
}

export enum StatusTwygoCoursesLabels {
  NOT_STARTED = "Não Iniciado",
  IN_PROGRESS = "Em Andamento",
  COMPLETED = "Completo",
  FAILED = "Reprovado",
}
